import { useQuery } from '@tanstack/react-query';
import { useCustomerScope } from '../contexts/AccountContext';
import { supabase } from '../lib/supabase';

export interface CustomerNetworkProjection {
  id: string;
  network_name: string;
  observed_at: string | null;
  received_at: string;
  health: 'healthy' | 'degraded' | 'offline' | 'unknown';
  coverage: 'complete' | 'partial' | 'none';
  is_stale: boolean;
  devices_total: number;
  devices_online: number;
  devices_offline: number;
  devices_unknown: number;
  active_alerts: number;
  devices: unknown;
  incidents: unknown;
  sources: unknown;
}

/** The projection is an allowlisted snapshot. It contains no management endpoints. */
export function useMissionControlNetworks(locationId: string) {
  const scope = useCustomerScope();
  return useQuery({
    queryKey: ['mission-control-networks', scope.key, locationId],
    enabled: scope.ready && scope.ids.length > 0 && Boolean(locationId),
    queryFn: async (): Promise<CustomerNetworkProjection[]> => {
      const { data, error } = await supabase
        .from('mission_control_network_customer_view')
        .select(
          'id,network_name,observed_at,received_at,health,coverage,is_stale,sources,devices_total,devices_online,devices_offline,devices_unknown,active_alerts,devices,incidents',
        )
        .eq('location_id', locationId)
        .in('customer_id', scope.ids)
        .order('network_name');
      if (error) throw error;
      return (data ?? []) as unknown as CustomerNetworkProjection[];
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
